import {html, css} from 'lit'
import {TBase} from '../../../wcl/base'


export class TUserEditView extends TBase 
{
    static styles = [ TBase.styles, css`` ]

    static properties = {
        ...TBase.properies,
        uid : { type: String, attribute: 'data-vx-uid' },
        url : { type: String, attribute: 'data-vx-resource'},
        api : { type: String, attribute: 'data-vx-api'}
    }

    constructor() {
        super()
    }

    render() {
        console.log('rendering user-edit', this.uid)
        var fields = [
            { name: 'uid'       , type: 'hidden'},
            { name: 'name'      , type: 'text' , label: 'Prénom Nom'  },
            { name: 'username'  , type: 'text' , label: `Nom d'utilisateur`},
            { name: 'password'  , type: 'password', label: 'Mot de passe' },
            { name: 'status'    , type: 'select', label: 'Statut', options: ['enabled', 'disabled', 'suspended', 'pending']}
        ]
        var buttons = [{label: 'enregistrer', action: 'submit', color: 'primary'}]
        var datasrc = this.url
        var desturl = this.api
        if(this.uid)  buttons.push({label: 'supprimer', action: 'delete', color: 'danger'})

        return html`
            ${super.render()}
            <div class="container-fluid pe-5 mt-5">
            <div class="row"><vx-card>UTILISATEURS / EDIT</vx-card></div>
            <div class="row pt-3">
                <vx-card
                    data-vx-header='Edition de fiche utilisateur'>
                    <vx-form
                        name='user'
                        method='POST'
                        url=${desturl}
                        data-vx-datasrc=${datasrc}
                        data-vx-fields=${JSON.stringify(fields)}
                        data-vx-buttons=${JSON.stringify(buttons)}
                    ></vx-form>
                </vx-card
        `
    }
}

if (!customElements.get('vx-user-edit-view')) 
    customElements.define('vx-user-edit-view', TUserEditView);

/*
    "uid": "001",
    "firstname": "Ahmed",
    "lastname": "Gabal",
    "email": "a.gabal@me.com",
    "tel": "07 89 77 14 01",
    "username": "a.gabal@me.com",
    "password": "****"


    input.id            = input.id || `${input.type}-${uuid()}`
    input.type          = input.type || 'text'
    input.name          = input.name || input.id
    input.label         = input.label || ''
    input.value         = input.value || ''
    input.placeholder   = input.placeholder || input.label
    input.options       = input.options || []
*/